<template>
	

    <div id="app">
		
		<router-view />			
			
    </div>
</template>
<script>
    export default {
        name: "home",
        data: function () {
            return {
                pageTitle: "Participant agreement",
                homeLink: process.env.VUE_APP_BEDP
            }
        }
    }
</script>